import { AppLabel, AppSpan, CustomContainer, FlexRow } from "src/style"

export const TicketChannels: React.FC = () => {
    return (
        <CustomContainer topMargin='3'>
            <AppLabel color='#000000' fontWeight='600'>Ticket channels</AppLabel>
            <CustomContainer
                minHeight='33.7' borderColor='#E2E8F0' radius='0.4'
                padding='2'
            >
                <CustomContainer bottomMargin='3'>
                    <FlexRow justifyContent="space-between">
                        <AppLabel color="#718096" textSize="1.2">Emails</AppLabel>
                        <AppSpan textSize="1.2" fontWeight="600" topMargin="-0.2">
                            50 
                            <AppSpan textSize="1.2" fontWeight="600" color='#4C6FFF' topMargin="-0.2"> (50%) </AppSpan>
                        </AppSpan>
                    </FlexRow>
                    <CustomContainer bgColor="#EDF2F7" radius="5" topMargin='0.7'>
                        <CustomContainer height="0.6" bgColor="#4C6FFF" width="80" sizeUnit="%"/>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer bottomMargin='3'>
                    <FlexRow justifyContent="space-between">
                        <AppLabel color="#718096" textSize="1.2">Call-ins</AppLabel>
                        <AppSpan textSize="1.2" fontWeight="600" topMargin="-0.2">
                            10 
                            <AppSpan textSize="1.2" fontWeight="600" color='#4C6FFF' topMargin="-0.2"> (50%) </AppSpan>
                        </AppSpan>
                    </FlexRow>
                    <CustomContainer bgColor="#EDF2F7" radius="5" topMargin='0.7'>
                        <CustomContainer height="0.6" bgColor="#66CB9F" width="80" sizeUnit="%"/>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer bottomMargin='3'>
                    <FlexRow justifyContent="space-between">
                        <AppLabel color="#718096" textSize="1.2">Facebook</AppLabel>
                        <AppSpan textSize="1.2" fontWeight="600" topMargin="-0.2">
                            10 
                            <AppSpan textSize="1.2" fontWeight="600" color='#4C6FFF' topMargin="-0.2"> (50%) </AppSpan>
                        </AppSpan>
                    </FlexRow>
                    <CustomContainer bgColor="#EDF2F7" radius="5" topMargin='0.7'>
                        <CustomContainer height="0.6" bgColor="#3B5999" width="80" sizeUnit="%"/>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer bottomMargin='3'>
                    <FlexRow justifyContent="space-between">
                        <AppLabel color="#718096" textSize="1.2">Twitter</AppLabel>
                        <AppSpan textSize="1.2" fontWeight="600" topMargin="-0.2">
                            10 
                            <AppSpan textSize="1.2" fontWeight="600" color='#4C6FFF' topMargin="-0.2"> (50%) </AppSpan>
                        </AppSpan>
                    </FlexRow>
                    <CustomContainer bgColor="#EDF2F7" radius="5" topMargin='0.7'>
                        <CustomContainer height="0.6" bgColor="#1DA1F2" width="80" sizeUnit="%"/>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer>
                    <FlexRow justifyContent="space-between">
                        <AppLabel color="#718096" textSize="1.2">Instagram</AppLabel>
                        <AppSpan textSize="1.2" fontWeight="600" topMargin="-0.2">
                            10 
                            <AppSpan textSize="1.2" fontWeight="600" color='#4C6FFF' topMargin="-0.2"> (50%) </AppSpan>
                        </AppSpan>
                    </FlexRow>
                    <CustomContainer bgColor="#EDF2F7" radius="5" topMargin='0.7'>
                        <CustomContainer height="0.6" bgColor="#E4405F" width="80" sizeUnit="%"/>
                    </CustomContainer>
                </CustomContainer>
            </CustomContainer>
        </CustomContainer>
    )
}